module.exports = __webpack_public_path__ + "static/media/sent.6bcdcfa7.svg";